<script setup lang="ts">
import FadeTransition from "~~/components/transition/FadeTransition.vue";
interface Props {
  option: {
    closeOnOutsideClick:boolean
  }
}
const props = defineProps<Props>();
const emit = defineEmits(["close"]);

const isShow = ref(true);

function handleClose() {
    isShow.value = false;
    setTimeout(() => {
        emit("close");
    }, 500);
}

function handleBackgroundClick() {
  if (props.option.closeOnOutsideClick) {
    handleClose();
  }
}
</script>

<template>
    <FadeTransition appear>
        <div class="app-dialog" v-if="isShow" v-on:click="handleBackgroundClick">
            <div class="app-dialog__box">
                <!-- <div class="app-dialog__box__top__actions">
				<div class="app-dialog__box__top__actions__close" @click="emit('close')">✕</div>
			</div> -->
                <div class="app-dialog__box__content">
                    <slot name="content"></slot>
                </div>
                <div class="app-dialog__box__actions" v-if="$slots.action">
                    <slot name="action" :close="handleClose"></slot>
                </div>
            </div>
        </div>
    </FadeTransition>
</template>

<style lang="scss" scoped>
.app-dialog {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);

    z-index: 1000;
    &__box {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        min-width: 100px;
        min-height: 100px;
        max-width: 90vw;

        background-color: white;

        border-radius: 24px;
        padding: 16px 24px;
        padding-top: 24px;
        &__top__actions {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            position: absolute;
            left: 0;
            top: 0;
            &__close {
                cursor: pointer;
                padding: 10px;
            }
        }
        &__content {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;

            text-align: center;
            white-space: pre-wrap;

            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
        }
        &__actions {
            display: flex;
            gap: 8px;

            margin-top: 16px;
        }
    }
}
</style>
